import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Chip } from "@mui/material";
import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import { randomId } from "@mui/x-data-grid-generator";
import { Button } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useSelector, useDispatch } from "react-redux";
import {
  updateProject,
  setProject,
  setClient,
  addProject,
  deleteProject,
  updateDeployment,
  getProject,
  loadProjectList,
} from "../actions/adminAction";

// Add Functionality
function EditToolbar(props) {
  const { setRows, setRowModesModel, projectsList, selectedProjects, dispatch, addProject } = props;
  const addNewProject = () => {
    const id = randomId();
    setRows((prev) => [
      { id, projectDesc: "", deploymentID: "", isNew: true },
      ...prev,
    ]);
    setRowModesModel((prev) => ({
      ...prev,
      [id]: { mode: GridRowModes.Edit, fieldToFocus: "projectDesc" },
    }));
  };

  const duplicateProjects = ()=>{
    // Check if project lists and selected project list available
    // Loop through selected projet list and find the details from selected project
    let selectedProjectDetails;
    
    if(selectedProjects.length){
      if(projectsList.data.length){
        selectedProjectDetails = projectsList.data?.filter((project)=>selectedProjects.includes(project.projectID));
      }
      // alternative for using modal for confirmation message
      // eslint-disable-next-line no-restricted-globals
      if(confirm("Are you sure you want to duplicate the records")){
        if(selectedProjectDetails.length){
          selectedProjectDetails.map((selectedProject)=>{
            // Update the row on the UI
            const id = randomId();
            setRows((prev) => [
              { id, projectDesc:selectedProject.projectDesc, clientId: selectedProject.clientId, selectedClient: selectedProject.clientId, status: selectedProject.status, FromDate: selectedProject.FromDate, ToDate:selectedProject.ToDate, isNew: true },
              ...prev,
            ]);

            setRowModesModel((prev) => ({
              ...prev,
              [id]: { mode: GridRowModes.Edit, fieldToFocus: "projectDesc" },
            }));
  
          })
        }
      }
    }
   else{
    alert("No project has been selected");
   }
  }

  return (
    <GridToolbarContainer>
      <Button color="primary" startIcon={<AddIcon />} onClick={addNewProject}>
        Add Project
      </Button>
      <Button color="primary" startIcon={<ContentCopyOutlinedIcon/> } onClick={duplicateProjects}>
        Duplicate Project
      </Button>
    </GridToolbarContainer>
  );
}

export default function ProjectGridTable({ setCurrentStep, setActiveTab }) {
  const dispatch = useDispatch();
  const projectsList = useSelector((state) => state.admin.projectsList);
  const selectedProject = useSelector((state) => state.admin.project);
  const deploymentsList = useSelector((state) => state.admin.deploymentsList);
  const clientsList = useSelector((state) => state.admin.clientsList);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [deleteID, setDeleteID] = useState();
  const [rows, setRows] = useState([]);
  const [rowModesModel, setRowModesModel] = useState({});

 
   // Function to check if any row is in edit mode
   const isAnyRowInEditMode = Object.values(rowModesModel).some(
    (rowMode) => rowMode.mode === GridRowModes.Edit
  );

  const handleOnRowClick = (params, event) => {
    const selectedClientId = params.row.selectedClient;
    setCurrentStep(params.row.status);
    dispatch(setProject({ projectID: params.row.projectID }));
    dispatch(setClient({ clientID: selectedClientId }));
  };

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleRowSelectionChange = (selectedRowID) => {
      setSelectedProjects(selectedRowID);
  };

  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleDeleteClick = (id) => () => {
    dispatch(deleteProject(id));
    setRows(rows.filter((row) => row.id !== id));
  };

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.id === id);
    if (editedRow && editedRow.isNew) {
      setRows(rows.filter((row) => row.id !== id));
    }
  };

  const processRowUpdate = (newRow) => {
    // Check whether add or update operation
    if (newRow.isNew) {
      if (newRow.projectDesc) dispatch(addProject(newRow));
      if(!isAnyRowInEditMode) dispatch(loadProjectList())
      return newRow;
    } else {
      // Format the FromDate/ToDate before saving
      const updatedRow = { ...newRow, isNew: false };
      setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));

      // Condition to determine the status

      // if configure, project Name empty or client is not selected = > configure project step 1
      // if configure, above field has value but deployment field is empty => configure deployment step
      // if configure, above field has value except device => configure device

      // Logic 1
      // const updateProgressStat = parseInt(updatedRow.status, 10);
      // updatedRow.status = updateProgressStat;

      // Logic 2
      const startDate = new Date(updatedRow.FromDate).getTime();
      const endDate = new Date(updatedRow.ToDate).getTime();

      const projectDeployments = deploymentsList.data?.filter(
        (deployment) => deployment.projectID === updatedRow.projectID
      );

      // 1969-12-31 11pm = 14400000 default setting of the datetime with dataGrid for empty datetime
      const isStartDateEmpty =
        startDate === 0 || startDate === 14400000 ? true : false;
      const isEndDateEmpty =
        endDate === 0 || endDate === 14400000 ? true : false;

      // if From Date and to Date is not null => complete
      if (!isStartDateEmpty && !isEndDateEmpty) {
        // Update the status of the project
        updatedRow.status = 5;
        setCurrentStep(updatedRow.status);

        // Update the toDate from deployment
        projectDeployments.map((deployment) => {
          const deploymentStartDate = new Date(deployment.fromDate).getTime();
          const deploymentEndDate = new Date(deployment.toDate).getTime();

          const isDeploymentStartDateEmpty =
            deploymentStartDate === 0 || deploymentStartDate === 14400000
              ? true
              : false;
          const isDeploymentEndDateEmpty =
            deploymentEndDate === 0 || deploymentEndDate === 14400000
              ? true
              : false;

          // Condition 1:  if end date empty => update the end date with project end date
          if (!isDeploymentStartDateEmpty && isDeploymentEndDateEmpty) {
            dispatch(
              updateDeployment(deployment.deploymentID, {
                ...deployment,
                toDate: new Date(endDate).toISOString(),
              })
            );
          }

          // Condition 2: if both start and end date is empty => update the deployment start date and end date with project end date(9am-6pm)
        });
      }
      // if From Date is not null and to Date is null => in progress
      else if (!isStartDateEmpty && isEndDateEmpty) {
        updatedRow.status = 4;
        setCurrentStep(updatedRow.status);
      }
      // if From Date or To Date or any other field in project is empty = > configure
      else {
        updatedRow.status = 1;
        setCurrentStep(updatedRow.status);
      }

      // To do: logic to set the step for configure deployment and configure device

      dispatch(updateProject(updatedRow.projectID, updatedRow));
      
      // Only reload the project list when all records not in edit mode
      if(!isAnyRowInEditMode) dispatch(loadProjectList())
      return updatedRow;
    }
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };


   //Re-render the project list whenever there is update on projects
   useEffect(() => {
    if (projectsList && projectsList.data) {
      const initialRows = projectsList.data.map((project) => ({
        id: project.projectID, // Use projectID as the unique identifier
        projectID: project.projectID,
        projectDesc: project.projectDesc,
        selectedClient: project?.client?.id,
        status: project.status,
        deploymentID: project.deploymentID,
        FromDate: project.FromDate,
        ToDate: project.ToDate,
        progress: project.progress,
      }));
      setRows(initialRows);
    }
  }, [projectsList.data]);


  const projectColumns = [
    // {
    //   field: "projectID",
    //   headerName: "Project ID",
    //   width: 150,
    //   editable: false,
    //   hide: true
    // },
    {
      field: "projectDesc",
      headerName: "Project",
      width: 200,
      editable: true,
    },
    {
      field: "selectedClient",
      headerName: "Client",
      type: "singleSelect",
      width: 150,
      editable: true,
      valueGetter: (params) => {
        const selectedClientId = params.row.selectedClient;
        return selectedClientId ? selectedClientId : null;
      },
      valueOptions: clientsList?.map((client) => ({
        value: client.id,
        label: client.title,
      })),
    },
    {
      field: "FromDate",
      headerName: "From",
      type: "dateTime",
      width: 200,
      editable: true,
      valueGetter: (params) => {
        return params.value;
      },
      valueFormatter: (params) => {
        if (params.value) {
          const validDate = new Date(params.value).getTime();
          if (validDate) {
            return new Date(params.value);
          }
        }
        return "";
      },
    },
    {
      field: "ToDate",
      headerName: "To",
      type: "dateTime",
      width: 200,
      editable: true,
      valueGetter: (params) => {
        return params.value;
      },
      valueFormatter: (params) => {
        if (params.value) {
          const validDate = new Date(params.value).getTime();
          if (validDate) {
            return new Date(params.value);
          }
        }
        return "";
      },
    },
    {
      field: "status",
      headerName: "Progress",
      width: 150,
      editable: true,
      renderCell: (params) => {
        let label = "Configuring";
        if (Number(params.value) === 5) {
          label = "Complete";
        } else if (Number(params.value) === 4) {
          label = "On lease";
        }

        const chipStyle = {
          minWidth: "100px",
          color: "white",
          backgroundColor: (() => {
            switch (params.value) {
              case 5:
                return "#66bb6a"; // Color for "Completed"
              case 4:
                return "#FFA500"; // Color for "To be configured"
              default:
                return "#5a5a5a"; // Default color for other statuses
            }
          })(),
        };

        return <Chip label={label} style={chipStyle} />;
      },
    },
    {
      field: "deploymentID",
      type: "actions",
      headerName: "Deployment",
      width: 150,
      editable: false,
      cellClassName: "actions",
      renderCell: (params) => {
        const buttonStyle = {
          minWidth: "30px",
          color: "white",
          backgroundColor: "#6dcfe9",
          borderRadius: "50rem",
        };
        const handleClick = () => {
          setActiveTab(1);
          dispatch(setProject({ projectID: params.row.projectID }));
          dispatch(setClient({ clientID: params.row.selectedClient}));
        };

        const filterData = deploymentsList.data?.filter(
          (deployment) => deployment.projectID === params.id
        );

        return (
          <Button onClick={handleClick} style={buttonStyle}>
            {filterData?.length}
          </Button>
        );
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "actions",
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              sx={{
                color: "primary.main",
              }}
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              sx={{
                color: "primary.secondary",
              }}
            />,
          ];
        }

        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            data-bs-toggle="modal"
            data-bs-target="#deleteUser"
            onClick={() => setDeleteID(id)}
            sx={{
              color: "#dd3545",
            }}
          />,
        ];
      },
    },
  ];

  return (
    <Box
      sx={{
        height: 500,
        width: "100%",
      }}
    >
      {/* Delete Modal */}
      <div
        className="modal fade"
        id="deleteUser"
        aria-labelledby="deleteUserLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content admin-list">
            <div className="modal-header">
              <h5 className="modal-title" id="deleteUserLabel">
                Delete Project
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              Are you sure you want to delete project {`${deleteID}`}?
              <br />
              <br />
              <b>
                <span className="text-danger text-center">
                  Warning: Delete project will disassociate the project id from
                  the deployments.
                </span>
              </b>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn admin-list-btn-secondary text-white"
                onClick={handleDeleteClick(deleteID)}
                data-bs-dismiss="modal"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>

      {rows && rows.length > 0 && clientsList && projectsList ? (
        <DataGrid
          sx={{
            color: "white",
            "& .MuiDataGrid-menuIconButton": {
              color: "white",
            },
            "& .MuiCheckbox-root": {
              color: "white",
            },

            "& .MuiDataGrid-sortIcon": {
              color: "white",
            },

            "& .MuiTablePagination-root": {
              bgcolor: "white",
            },
            "& .MuiDataGrid-cell": {
              border: 0,
            },
            "& .MuiDataGrid-row:hover": {
              bgcolor: "primary.main",
            },
            "& .MuiDataGrid-cell:hover": {
              bgcolor: "none",
            },
            "& .MuiDataGrid-cell:focus": {
              bgcolor: "primary.light",
            },
          }}
          rows={rows}
          columns={projectColumns}
          editMode="row"
          getRowId={(row) => row.id}
          // initialState={{
          //   pagination: {
          //     paginationModel: {
          //       pageSize: 10,
          //     },
          //   },
          // }}
          pagination={false}
          rowModesModel={rowModesModel}
          onRowModesModelChange={handleRowModesModelChange}
          pageSizeOptions={[5]}
          checkboxSelection
          onRowSelectionModelChange={handleRowSelectionChange}
          // disableRowSelectionOnClick
          onRowEditStop={handleRowEditStop}
          processRowUpdate={processRowUpdate}
          onRowClick={handleOnRowClick}
          slots={{
            toolbar: EditToolbar,
          }}
          slotProps={{
            toolbar: { setRows, setRowModesModel, selectedProjects, projectsList, dispatch, addProject },
          }}
        />
      ) : (
        <CircularProgress />
      )}
    </Box>
  );
}
